module.exports = __webpack_public_path__ + "static/media/menu.7b6b479c.svg";